import React, { useContext, useEffect, useCallback, useState } from 'react';
import { StyleContext } from '../../context/StyleContext';
import { ApiContext } from '../../context/ApiContext';
import { Form, Row, Col, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaTimes, FaInfoCircle } from "react-icons/fa";
import LoadingScreen from '../LoadingScreen';

export default function ModalRelatorioMatriz({ setModalRelatorio }) {
    const { ObterRelatorioMatriz, RelatorioMatriz, loading, ObterCapacidade, CapacidadeObter } = useContext(ApiContext)
    const { btnCriar, btnVer } = useContext(StyleContext)

    const descricaoNotas = {
        1: "Nota 1 (pior)",
        2: "Nota 2 (abaixo da média)",
        3: "Nota 3 (média)",
        4: "Nota 4 (acima da média)",
        5: "Nota 5 (melhor)",
    };

    const descricaoLinhas = {
        0: "Aderência a Missão e Processo",
        1: "Qualidade e Pontualidade de Dados e Informações",
        2: "Robustez das Aplicações",
        3: "Utilização",
        4: "Papel Futuro da Aplicação",
        5: "Complexidade",
        6: "Avaliação e confiança de especialistas",
        7: "Fatores de Mudança e Manutenção",
        8: "Suportabilidade",
        9: "Disponibilidade e custo das habilidades de suporte",
        10: "Alinhamento da Arquitertura",
        11: "Alinhamento Base Tecnológica",
        12: "Amplitude e Escalabilidade",
        13: "Execução Técnica",
        14: "Licença, Custos do Contrato de Suporte",
        15: "Custos de serviço, manutenção e melhoria",
        16: "Custo total do ciclo de vida da aplicação",
    };

    const somasPorSistema = RelatorioMatriz?.map(col => {
        const notas = col.avaliacoes.map(a => Number(a.nota) || 0);

        return {
            sistema: col.sistema?.nome,
            grupo1: notas.slice(0, 5).reduce((acc, n) => acc + n, 0),
            grupo2: notas.slice(5, 10).reduce((acc, n) => acc + n, 0),
            grupo3: notas.slice(10, 14).reduce((acc, n) => acc + n, 0),
            grupo4: notas.slice(14, 17).reduce((acc, n) => acc + n, 0),
        };
    }) ?? [];

    const renderTooltip = (nota, rowIndex, props) => (
        <Tooltip id={`tooltip-${rowIndex}`} {...props}>
            <b>{descricaoNotas[nota] || "Sem nota"}</b>
            <br />
            {descricaoLinhas[rowIndex] || "Sem descrição"}
        </Tooltip>
    );

    useEffect(() => {
        ObterRelatorioMatriz()
        ObterCapacidade()
    }, [])

    return (
        <>
            {loading && <LoadingScreen />}
            <div className="modal-novo">
                <div className="modal-novo-interno-matriz">
                    <div className="header-modal">
                        <h1 className="h1-modal">Relatório Matriz de Avaliação</h1>
                        <div className="btn-close-modal" onClick={() => setModalRelatorio(false)}>
                            <FaTimes />
                        </div>
                    </div>
                    <form>
                        <div className="modal-content">
                            <Form.Group>
                                <Form.Label className="mb-0">Capacidade de Negócio Avaliada</Form.Label>
                                <p className='span-bsc'>{CapacidadeObter?.nivel ? `${CapacidadeObter.nivel} - ` : ''}{CapacidadeObter?.titulo}</p>
                            </Form.Group>

                            {RelatorioMatriz && (
                                <div style={{ display: 'flex', maxHeight: '600px', overflow: 'auto', }}>
                                    {RelatorioMatriz && RelatorioMatriz.some(r => r.avaliacoes && r.avaliacoes.length > 0) && (
                                        <div style={{ marginTop: '70px' }}>
                                            <div className='card-matriz' style={{ height: '166px', backgroundColor: '#e26b0a' }}>
                                                Valor Aplicação Aderência Negócio e Processos
                                            </div>
                                            <div className='card-matriz' style={{ height: '187px', backgroundColor: '#31869b' }}>
                                                Risco Operacional
                                            </div>
                                            <div className='card-matriz' style={{ height: '116px', backgroundColor: '#0070c0' }}>
                                                Riscos <br /> Técnicos
                                            </div>
                                            <div className='card-matriz' style={{ height: '150px', backgroundColor: '#60497a' }}>
                                                Custos
                                            </div>
                                        </div>
                                    )}

                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: `250px repeat(${RelatorioMatriz.length}, 200px)`,
                                            gap: "0 10px",
                                            alignItems: "center",
                                            textAlign: "center",

                                            paddingTop: '5px',
                                        }}
                                    >
                                        <div></div>

                                        {RelatorioMatriz.map((item, index) => (
                                            <div key={index} className="span-sistema" style={{ fontWeight: "bold", marginBottom: "5px" }}>
                                                {item?.sistema?.nome}
                                            </div>
                                        ))}

                                        {Array.from(
                                            { length: Math.max(...RelatorioMatriz.map(col => col.avaliacoes.length)) },
                                            (_, rowIndex) => {
                                                let style = {};
                                                let bgColor = {};
                                                if (rowIndex < 5) {
                                                    style = { borderLeft: "10px solid #e26b0a", borderBottom: "1px solid #ccc" };
                                                    bgColor = { backgroundColor: "#fde9d9", textAlign: "left", fontWeight: "500", padding: "4px", color: "#000" }
                                                } else if (rowIndex < 10) {
                                                    style = { borderLeft: "10px solid #31869b", borderBottom: "1px solid #ccc" };
                                                    bgColor = { backgroundColor: "#daeef3", textAlign: "left", fontWeight: "500", padding: "4px", color: "#000" }
                                                } else if (rowIndex < 14) {
                                                    style = { borderLeft: "10px solid #0070c0", borderBottom: "1px solid #ccc" };
                                                    bgColor = { backgroundColor: "#c5d9f1", textAlign: "left", fontWeight: "500", padding: "4px", color: "#000" }
                                                } else if (rowIndex < 17) {
                                                    style = { borderLeft: "10px solid #60497a", borderBottom: "1px solid #ccc" };
                                                    bgColor = { backgroundColor: "#e4dfec", textAlign: "left", fontWeight: "500", padding: "4px", color: "#000" }
                                                }

                                                return (
                                                    <>
                                                        <div style={bgColor}>
                                                            {descricaoLinhas[rowIndex] || ""}
                                                        </div>

                                                        {RelatorioMatriz.map((col, colIndex) => (
                                                            <div key={`${rowIndex}-${colIndex}`} style={style}>
                                                                {col.avaliacoes[rowIndex] ? col.avaliacoes[rowIndex].nota : "0"}
                                                                <OverlayTrigger
                                                                    placement="right"
                                                                    delay={{ show: 250, hide: 400 }}
                                                                    overlay={(props) =>
                                                                        renderTooltip(col.avaliacoes[rowIndex]?.nota, rowIndex, props)
                                                                    }
                                                                >
                                                                    <button
                                                                        type="button"
                                                                        style={{
                                                                            border: "none",
                                                                            background: "none",
                                                                            cursor: "pointer",
                                                                            float: "right"
                                                                        }}
                                                                    >
                                                                        <FaInfoCircle style={{ color: "#0d6efd" }} />
                                                                    </button>
                                                                </OverlayTrigger>
                                                            </div>
                                                        ))}
                                                    </>
                                                );
                                            }
                                        )}
                                        <div style={{ backgroundColor: "#e26b0a", color: "#fff", fontWeight: "bold" }}>
                                            Valor Aplicação e Aderência Negócio e Processos
                                        </div>
                                        {somasPorSistema.map((s, i) => (
                                            <div style={{ backgroundColor: '#fde9d9', padding: '10px 0', color: "#000" }} key={`g1-${i}`} >{s.grupo1 ? s.grupo1 : "0"}</div>
                                        ))}

                                        <div style={{ backgroundColor: "#31869b", color: "#fff", fontWeight: "bold" }}>
                                            Risco Operacional
                                        </div>
                                        {somasPorSistema.map((s, i) => (
                                            <div style={{ backgroundColor: '#daeef3', color: "#000" }} key={`g2-${i}`}>{s.grupo2}</div>
                                        ))}

                                        <div style={{ backgroundColor: "#0070c0", color: "#fff", fontWeight: "bold" }}>
                                            Riscos Técnicos
                                        </div>
                                        {somasPorSistema.map((s, i) => (
                                            <div style={{ backgroundColor: '#c5d9f1', color: "#000" }} key={`g3-${i}`}>{s.grupo3}</div>
                                        ))}

                                        <div style={{ backgroundColor: "#60497a", color: "#fff", fontWeight: "bold" }}>
                                            Custos
                                        </div>
                                        {somasPorSistema.map((s, i) => (
                                            <div style={{ backgroundColor: '#e4dfec', color: "#000" }} key={`g4-${i}`}>{s.grupo4}</div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="footer-modal-criar-demanda">
                            <div></div>
                            <button className="btn-dash btn-criar" style={btnCriar} onClick={() => setModalRelatorio(false)}>Fechar</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}